export default function Waveform() {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="6.4707" width="2" height="6.47059" rx="1" fill="currentColor" />
      <rect x="3" y="2.58838" width="2" height="14.2353" rx="1" fill="currentColor" />
      <rect x="6" y="5.17676" width="2" height="9.05882" rx="1" fill="currentColor" />
      <rect x="12" width="2" height="19.4118" rx="1" fill="currentColor" />
      <rect x="9" y="2.58838" width="2" height="14.2353" rx="1" fill="currentColor" />
      <rect x="18" y="6.70605" width="2" height="6" rx="1" fill="currentColor" />
      <rect x="15" y="2.58838" width="2" height="14.2353" rx="1" fill="currentColor" />
    </svg>
  );
}
